import { useEffect, useState } from "react";
import { Button, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { MdOutlineAssignmentInd } from "react-icons/md";
import usersApi from "../../../api/userApi";
import Pagination from "../../../components/Pagination";
import ReassignCustomerModal from "./ReassignCustomerModal";
const PersonalCustomers = ({ referralCode }) => {
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  useEffect(() => {
    if (!referralCode) return;

    fetchCustomers();
  }, [referralCode]);

  const fetchCustomers = async () => {
    try {
      const res = await usersApi.getCustomersListByReferralCode(
        referralCode,
        page,
        pageSize,
      );

      setCustomers(res.data.content || []);
      setTotalPages(res.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomers([]);
      setTotalPages(0);
    } finally {
      // Reset page to 0 if referral code changes
      if (page !== 0) {
        setPage(0);
      }
    }
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("franchise-level1", selectedPage);
  };
  const handleOpenModal = (customer) => {
    setSelectedCustomer(customer);
    setShowModal(true);
  };
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
            <th>Reassign</th>
          </tr>
        </thead>
        <tbody>
          {customers.length > 0 ? (
            customers.map((customer, index) => (
              <tr key={index}>
                <td>{customer.userName}</td>
                <td>{customer.userEmail}</td>
                <td>{customer.countryName}</td>

                <td className="text-center">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-${index}`}>
                        Move to another franchise
                      </Tooltip>
                    }
                  >
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleOpenModal(customer)}
                    >
                      <MdOutlineAssignmentInd />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No customers found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {customers.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
      <ReassignCustomerModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        selectedCustomer={selectedCustomer}
        currentReferralCode={referralCode}
        refreshCustomers={fetchCustomers}
      />
    </>
  );
};

export default PersonalCustomers;
